import { Routes, Route } from 'react-router-dom';


import Layout from '../NewUPT/shared/Layout';


import Home from '../NewUPT/homePage/NewUPThomepage.jsx';


import Office from '../../src/NewUPT/office/OfficeDisplay.jsx';


import Staff from '../NewUPT/doctorInfo/DoctorView.jsx';


import Insurance from '../../src/NewUPT/insuranceDetails/insurancePage.jsx';


import Appointments from '../NewUPT/appointments/AppointmentScheduler.jsx';


import RegisterPatient from '../../src/NewUPT/registration/registerPatient.jsx';


import StaffPatientRegistration from '../../src/NewUPT/registration/StaffPatientRegistration.jsx';


import RegisterStaff from '../../src/NewUPT/registration/registerDoctor.jsx';


import LoginPatient from '../../src/NewUPT/loginServices/PatientLogin.jsx';


import LoginDoctor from '../../src/NewUPT/loginServices/DoctorLogin.jsx';


import PatientDashboard from '../../src/NewUPT/DashBoard/PatientDashBoard.jsx';


import DoctorDashboard from '../../src/NewUPT/DashBoard/DoctorDashboard.jsx';


import InsurancePatientReg from '../../src/NewUPT/registration/insurancePatientRegistration.jsx';


import RegisterOffice from '../../src/NewUPT/registration/registerOffice.jsx';


import OfficeSchedule from '../../src/NewUPT/registration/officeScheduleRegistration.jsx';


import OfficeScheduleManager from '../NewUPT/office/OfficeScheduleManager.jsx';


import PatientAuthorization from '../../src/NewUPT/registration/patientAuthorizationRegistration.jsx';


import RegisterInsurance from '../../src/NewUPT/registration/registerInsurance.jsx';


import ProcedureDiagnosis from '../../src/NewUPT/registration/registrerProcedureDiagnosis.jsx';


import RegisterAdmin from '../../src/NewUPT/Security/RegisterUser.jsx';


import RegisterPromotion from '../../src/NewUPT/promotion/CreatePromotion.jsx';


import RegisterPointItem from '../../src/NewUPT/points/InventoryManager.jsx';


import ContentPage from '../../src/NewUPT/ContentCreater/ContentHandler.jsx'; // For dynamic content


import Terms from '../NewUPT/staticPages/Terms.jsx';


import Privacy from '../NewUPT/staticPages/Privacy.jsx';


import Contact from '../NewUPT/staticPages/Contact.jsx';


import SearchPopupPage from '../NewUPT/popUps/searchPopupPage.jsx';


import ContentDisplay from '../NewUPT/ContentDisplay/ContentDisplay.jsx';


import AllPatients from '../NewUPT/patientInfo/AllPatients.jsx'


import ProcedureDiagnosisManager from "../NewUPT/procedureDiagnosis/ProcedureDiagnosisManager.jsx";


import ProcedureDiagnosisSelector from '../NewUPT/procedureDiagnosis/ProcedureDiagnosisSelector.jsx';


import InsuranceRecordSelector from '../NewUPT/patientInfo/InsuranceRecordSelector.jsx';


import OfficeSelector from '../NewUPT/office/OfficeSearch.jsx'


import AppointmentPopup from '../NewUPT/appointments/AppointmentPopup.jsx';


import RatingPopup from '../NewUPT/Rating/updateRatingPatient.jsx'


import RatingAdminView from '../NewUPT/Rating/AdminRatingView.jsx'


import PointPatientInventory from '../NewUPT/points/PatientInventory.jsx'


import PoinrPatientReceipt from '../NewUPT/points/PatientReceipts.jsx'


import CreateMissingPointsBank from '../NewUPT/points/CreateMissingPointsBank.jsx';


import FrontDeskCheckIn from '../NewUPT/FrontDesk/FrontDeskCheckIn.jsx'


import ManageClockTimecard from '../NewUPT/ClockInService/ManagerClockTimecard.jsx'


import Superbill from '../NewUPT/superbill/SuperbillPage.jsx'


import SuperbillCreator from "../NewUPT/superbill/SuperbillCreator.jsx";


import AuthorizationHoldPage from "../NewUPT/AuthorizationHold/AuthorizationHoldPage.jsx";


import AuthorizationHoldFlagManager from "../NewUPT/AuthorizationHold/AuthorizationHoldFlagManager.jsx";


import ClinicalTemplateAdminPage from "../NewUPT/clinicalNotes/ClinicalTemplateAdminPage.jsx";

import ClinicalNotePage from "../NewUPT/clinicalNotes/ClinicalNotePage.jsx";


import HeadSkullPT from '../NewUPT/staticPages/WhereIsPain/HeadSkullPT.jsx';


import NeckCervicalPT from '../NewUPT/staticPages/WhereIsPain/NeckCervicalPT.jsx';


import ShoulderRegionPT from '../NewUPT/staticPages/WhereIsPain/ShoulderRegionPT.jsx';


import UpperArmPT from '../NewUPT/staticPages/WhereIsPain/UpperArmPT.jsx';


import ElbowForearmPT from '../NewUPT/staticPages/WhereIsPain/ElbowForearmPT.jsx';


import WristHandPT from "../NewUPT/staticPages/WhereIsPain/WristHandPT.jsx";


import ChestPT from "../NewUPT/staticPages/WhereIsPain/ChestPT.jsx";


import AbdomenCorePT from "../NewUPT/staticPages/WhereIsPain/AbdomenCorePT.jsx";


import PelvisHipsFrontPT from "../NewUPT/staticPages/WhereIsPain/PelvisHipsFrontPT.jsx";


import ThighFrontPT from "../NewUPT/staticPages/WhereIsPain/ThighFrontPT.jsx";


import InnerThighPT from "../NewUPT/staticPages/WhereIsPain/InnerThighPT.jsx";


import LowerLegFrontPT from "../NewUPT/staticPages/WhereIsPain/LowerLegFrontPT.jsx";


import AnkleFootPT from "../NewUPT/staticPages/WhereIsPain/AnkleFootPT.jsx";


import HeadNeckBackPT from "../NewUPT/staticPages/WhereIsPain/HeadNeckBackPT.jsx";


import UpperBackPT from "../NewUPT/staticPages/WhereIsPain/UpperBackPT.jsx";


import ShoulderBackPT from "../NewUPT/staticPages/WhereIsPain/ShoulderBackPT.jsx";


import LowerBackPT from "../NewUPT/staticPages/WhereIsPain/LowerBackPT.jsx";


import PelvisHipsBackPT from "../NewUPT/staticPages/WhereIsPain/PelvisHipsBackPT.jsx";


import ThighBackPT from "../NewUPT/staticPages/WhereIsPain/ThighBackPT.jsx";


import KneeBackPT from "../NewUPT/staticPages/WhereIsPain/KneeBackPT.jsx";


import CalfPT from "../NewUPT/staticPages/WhereIsPain/CalfPT.jsx";


import AnkleFootBackPT from "../NewUPT/staticPages/WhereIsPain/AnkleFootBackPT.jsx";


import NoFaultPT from "../NewUPT/staticPages/NoFaultPT.jsx";


import WorkersCompPT from "../NewUPT/staticPages/WorkersCompPT.jsx";


const RoutesComponent = () => {


  return (


    <Routes>


      <Route element={<Layout />}>


        <Route path="/" element={<Home />} />


        <Route path="/office" element={<Office />} />


        <Route path="/staff" element={<Staff />} />


        <Route path="/insurance" element={<Insurance />} />


        <Route path="/appointments" element={<Appointments />} />


        <Route path="/dashboard/patient" element={<PatientDashboard />} />


        <Route path="/register/staff-patient" element={<StaffPatientRegistration />} />


        <Route path="/dashboard/doctor" element={<DoctorDashboard />} />


        <Route path="/register/insurance-patient" element={<InsurancePatientReg />} />


        <Route path="/register/office" element={<RegisterOffice />} />


        <Route path="/register/schedule" element={<OfficeSchedule />} />


        <Route path="/office-schedule-manager" element={<OfficeScheduleManager />} />


        <Route path="/register/authorization" element={<PatientAuthorization />} />


        <Route path="/register/insurance" element={<RegisterInsurance />} />


        <Route path="/register/procedure-diagnosis" element={<ProcedureDiagnosis />} />


        <Route path="/register/admin" element={<RegisterAdmin />} />


        <Route path="/register/promotion" element={<RegisterPromotion />} />


        <Route path="/register/point-item" element={<RegisterPointItem />} />


        <Route path="/content/edit/:id" element={<ContentPage />} />


        <Route path="/content-creator" element={<ContentPage />} />


        <Route path="/register/patient" element={<RegisterPatient />} />


        <Route path="/register/staff" element={<RegisterStaff />} />


        <Route path="/login/patient" element={<LoginPatient />} />


        <Route path="/login/doctor" element={<LoginDoctor />} />


        <Route path="/terms" element={<Terms />} />


        <Route path="/privacy" element={<Privacy />} />


        <Route path="/contact" element={<Contact />} />


        <Route path="/content/:id" element={<ContentDisplay />} />


        <Route path="/allpatients" element={<AllPatients />} />


       <Route path="/procedure-diagnosis-manager" element={<ProcedureDiagnosisManager />}/>


        <Route path="/select-procedure-diagnosis" element={<ProcedureDiagnosisSelector />} />


        <Route path="/appointmentPopup" element={<AppointmentPopup />} />


        <Route path="/frontdeskcheckin" element={<FrontDeskCheckIn />} />


        <Route path="/pointpatientinventory" element={<PointPatientInventory />} />


        <Route path="/points/create-missing" element={<CreateMissingPointsBank />} />


        <Route path="/ratingadminview" element={<RatingAdminView />} />


        <Route path="/patientreceipt" element={<PoinrPatientReceipt />} />


        <Route path="/manageclocktimecard" element={<ManageClockTimecard />} />


        <Route path="/superbill" element={<Superbill />} />


        <Route path="/superbill/create" element={<SuperbillCreator />} />


        <Route path="/authorization-holds" element={<AuthorizationHoldPage />} />


        <Route path="/authorization-hold-flags" element={<AuthorizationHoldFlagManager />} />

        <Route path="/clinical-template-setup" element={<ClinicalTemplateAdminPage />} />

        <Route path="/clinical-notes/:clinicalNoteId" element={<ClinicalNotePage />} />


        <Route path="/pain/head" element={<HeadSkullPT />} />


        <Route path="/pain/neckCervicalSpine" element={<NeckCervicalPT />} />


        <Route path="/pain/shoulderRegion" element={<ShoulderRegionPT />} />


        <Route path="/pain/upperArm" element={<UpperArmPT />} />


        <Route path="/pain/elbowForearm" element={<ElbowForearmPT />} />


        <Route path="/pain/wristHand" element={<WristHandPT />} />


        <Route path="/pain/chest" element={<ChestPT />} />


        <Route path="/pain/abdomenCore" element={<AbdomenCorePT />} />


        <Route path="/pain/pelvisHipsFront" element={<PelvisHipsFrontPT />} />


        <Route path="/pain/thighFront" element={<ThighFrontPT />} />


        <Route path="/pain/innerThigh" element={<InnerThighPT />} />


        <Route path="/pain/lowerLegFront" element={<LowerLegFrontPT />} />


        <Route path="/pain/ankleFoot" element={<AnkleFootPT />} />


        <Route path="/pain/headNeckBack" element={<HeadNeckBackPT />} />


        <Route path="/pain/upperBack" element={<UpperBackPT />} />


        <Route path="/pain/shoulderBack" element={<ShoulderBackPT />} />


        <Route path="/pain/lowerBack" element={<LowerBackPT />} />


        <Route path="/pain/pelvisHipsBack" element={<PelvisHipsBackPT />} />


        <Route path="/pain/thighBack" element={<ThighBackPT />} />


        <Route path="/pain/kneeBack" element={<KneeBackPT />} />


        <Route path="/pain/calf" element={<CalfPT />} />


        <Route path="/pain/ankleFootBack" element={<AnkleFootBackPT />} />


        <Route path="/no-fault" element={<NoFaultPT />} />


        <Route path="/workers-comp" element={<WorkersCompPT />} />


      </Route>


      {/* Public routes (not wrapped with Layout) */}


      <Route path="/search-popup" element={<SearchPopupPage />} />


       <Route path="/insurance-record-selector" element={<InsuranceRecordSelector />} />


       <Route path="/office-search" element={<OfficeSelector />} />


       <Route path="/ratingpopup" element={<RatingPopup />} />


    </Routes>


  );


};


export default RoutesComponent;
